export const getMissingPrescriberMessage = (action: string) =>
  `A prescriber must be selected before ${action}.`
